"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _IconBubbleButton = _interopRequireDefault(require("../../Buttons/IconBubbleButton"));

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

var _SideNav = require("./SideNav.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Side Navigation Drawer
 */
var SideNav = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SideNav, _React$PureComponent);

  var _super = _createSuper(SideNav);

  function SideNav(props) {
    var _this;

    _classCallCheck(this, SideNav);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openSubNav", function (navItem) {
      var activeMenuIds = _this.state.activeMenuIds;

      if (activeMenuIds[0] === navItem.id) {
        _this.setState({
          isOpen: true
        });
      } else {
        _this.setState({
          activeMenuIds: [navItem.id],
          isOpen: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeSubNav", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNavItemClick", function (navItem) {
      var updateValue;

      if (navItem.id !== _this.state.activeMenuIds[0]) {
        updateValue = {
          activeMenuIds: [navItem.id],
          isOpen: false
        };
      } else {
        updateValue = {
          activeMenuIds: [navItem.id]
        };
      }

      _this.setState(updateValue, function () {
        navItem.onClick();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubNavItemClick", function (navItem, subNavItem) {
      _this.setState({
        activeMenuIds: [navItem.id, subNavItem.id],
        isOpen: false
      }, function () {
        return subNavItem.onClick ? subNavItem.onClick() : console.warn("SubNav onClick handler was not provided for id: ".concat(subNavItem.id)); // eslint-disable-line no-console
      });
    });

    _this.state = {
      activeMenuIds: props.activeMenuIds,
      isOpen: false
    };
    return _this;
  }

  _createClass(SideNav, [{
    key: "renderSubNav",
    value: function renderSubNav() {
      var _this2 = this;

      var navConfig = this.props.navConfig;
      var _this$state = this.state,
          activeMenuIds = _this$state.activeMenuIds,
          isOpen = _this$state.isOpen;
      var activeParentObject = navConfig.find(function (option) {
        // the following is a quick type coercion and is probably the only valid reason to do strung concatenation
        return option.id + '' === activeMenuIds[0] + ''; // eslint-disable-line prefer-template
      });
      return activeParentObject ? /*#__PURE__*/_react.default.createElement(_SideNav.SubNav, {
        isOpen: isOpen
      }, /*#__PURE__*/_react.default.createElement(_SideNav.SubNavPadding, null, /*#__PURE__*/_react.default.createElement(_SideNav.SubNavHeader, null, /*#__PURE__*/_react.default.createElement(_IconBubbleButton.default, {
        onClick: this.closeSubNav,
        dataTestId: "close-sub-nav",
        iconName: "arrow-left"
      }), /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
        dataTestId: "sub0-nav-title"
      }, /*#__PURE__*/_react.default.createElement("strong", null, activeParentObject.subNav && activeParentObject.label))), /*#__PURE__*/_react.default.createElement(_SideNav.SubNavOptionsWrapper, null, activeParentObject.subNav && activeParentObject.subNav.map(function (navItem, index) {
        return /*#__PURE__*/_react.default.createElement(_SideNav.SubNavOption // the following is a quick type coercion and is probably the only valid reason to do strung concatenation
        , {
          active: navItem.id && navItem.id + '' === activeMenuIds[1] + '' // eslint-disable-line prefer-template
          ,
          onClick: function onClick() {
            return _this2.handleSubNavItemClick(activeParentObject, navItem);
          },
          "data-test-id": "option-".concat(navItem.id || index),
          key: "option-".concat(navItem.id || index)
        }, navItem.label);
      })))) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          navConfig = _this$props.navConfig;
      var activeMenuIds = this.state.activeMenuIds;
      return /*#__PURE__*/_react.default.createElement(_SideNav.MenuWrapper, {
        "data-test-id": "side-nav"
      }, this.renderSubNav(), /*#__PURE__*/_react.default.createElement(_SideNav.Menu, {
        className: className
      }, navConfig.map(function (navItem, index) {
        return /*#__PURE__*/_react.default.createElement(_SideNav.MenuOption // the following is a quick type coercion and is probably the only valid reason to do strung concatenation
        , {
          active: navItem.id && navItem.id + '' === activeMenuIds[0] + '' // eslint-disable-line prefer-template
          ,
          "data-test-id": "option-".concat(navItem.id || index),
          key: "option-".concat(navItem.id || index),
          onClick: navItem.subNav ? function () {
            return _this3.openSubNav(navItem);
          } : function () {
            return _this3.handleNavItemClick(navItem);
          }
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          dataTestId: "menu-icon-".concat(navItem.label),
          iconName: navItem.iconName,
          size: "large",
          colorTheme: "overDark"
        }), /*#__PURE__*/_react.default.createElement(_SideNav.MenuLabel, {
          alignment: "center",
          dataTestId: "menu-label-".concat(navItem.label),
          colorTheme: "overDark"
        }, navItem.label));
      })));
    }
  }]);

  return SideNav;
}(_react.default.PureComponent);

_defineProperty(SideNav, "propTypes", {
  /** Used to mark active menu items.
   * Position 0 is the top tier, and position 1 is the sub-nav.
   * The component copies initial props to internal state and runs on that after mount.
   * */
  activeMenuIds: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** navConfig to be displayed in side nav.
   * If you provide a subNav prop, it will trump the onclick if it is also provided.
   *  */
  navConfig: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    iconName: _propTypes.default.string,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    subNav: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })).isRequired
});

_defineProperty(SideNav, "defaultProps", {
  activeMenuIds: [],
  className: ''
});

var _default = SideNav;
exports.default = _default;